import React from "react";

function ServicesArea() {
  return (
    <div>
      <div className="row">
        <div className="col-md-4 overview-list">
          <li className="servise-camb">
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/campbellca/">
              <span>Campbell</span>{" "}
            </a>
          </li>
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/cupertinoca/">
              <span>Cupertino</span>
            </a>
          </li>
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/fremontca/">
              <span>Fremont</span>{" "}
            </a>
          </li>
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/losaltosca/">
              <span>Los Altos</span>
            </a>
          </li>
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/losgatosca/">
              <span>Los Gatos</span>
            </a>
          </li>
        </div>
        <div className="col-md-4 overview-list">
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/milpitasca/">
              <span>Milpitas</span>
            </a>
          </li>
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/mountainviewca/">
              <span>Mountain View</span>
            </a>
          </li>
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/newarkca/">
              <span>Newark</span>
            </a>
          </li>
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/paloaltoca/">
              <span>Palo Alto</span>
            </a>
          </li>
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/sanjoseca/">
              <span>San Jose</span>
            </a>
          </li>
        </div>
        <div className="col-md-4 overview-list">
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/santaclaraca/">
              <span>Santa Clara</span>
            </a>
          </li>
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/saratogaca/">
              <span>Saratoga</span>
            </a>
          </li>
          <li>
            <i className="fa-solid fa-check" />
            &nbsp;&nbsp;
            <a href="/sunnyvaleca/">
              <span>Sunnyvale</span>
            </a>
          </li>
        </div>
      </div>
    </div>
  );
}

export default ServicesArea;
